import { Link } from "react-router-dom";
import { BRANDS } from "@/lib/data";

export default function HomeBrands() {
  return (
    <section className="bg-white py-24 md:py-28 border-y border-[#e4e4e7]" data-testid="home-brands">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <div>
            <div className="overline mb-4">Parceiros</div>
            <h2 className="font-display font-bold uppercase text-3xl md:text-4xl text-[#222] tracking-tight">
              Marcas que confiam em nós.
            </h2>
          </div>
          <Link to="/marcas" className="font-mono-cet text-xs uppercase tracking-widest text-[#0d4c7d] hover:text-[#1FA8E0]">
            Ver todas →
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {BRANDS.map((b) => (
            <div
              key={b.name}
              data-testid={`brand-${b.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="brand-tile flex items-center justify-center h-24 px-4 overflow-hidden"
            >
              {b.logo ? (
                <img
                  src={b.logo}
                  alt={b.name}
                  loading="lazy"
                  className="max-h-16 max-w-full object-contain"
                />
              ) : (
                <span className="text-xl md:text-2xl">{b.name}</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
